// utils/fingerprint.ts

async function getCanvasFingerprint(): Promise<string> {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''

  canvas.width = 200
  canvas.height = 50

  ctx.textBaseline = 'top'
  ctx.font = '14px Arial'
  ctx.fillStyle = '#f60'
  ctx.fillRect(125, 1, 62, 20)
  ctx.fillStyle = '#069'
  ctx.fillText('TakeCost fingerprint', 2, 15)
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
  ctx.fillText('TakeCost fingerprint', 4, 17)

  return canvas.toDataURL()
}

function getWebGLFingerprint(): string {
  const canvas = document.createElement('canvas')
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
  if (!gl || !(gl instanceof WebGLRenderingContext)) return ''

  const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
  if (!debugInfo) return ''

  const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
  const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
  return `${vendor}~${renderer}`
}

async function hashString(str: string): Promise<string> {
  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export async function createFingerprint(): Promise<string> {
  const components = [
    await getCanvasFingerprint(),
    getWebGLFingerprint(),
    `${screen.width}x${screen.height}x${screen.colorDepth}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.language,
    navigator.hardwareConcurrency?.toString() || '',
    (navigator as any).deviceMemory?.toString() || '',
    navigator.maxTouchPoints?.toString() || '',
    navigator.platform || '',
  ]

  return hashString(components.join('|||'))
}
